// extracted by mini-css-extract-plugin
module.exports = {"body":"_1Cr1J","cbdBannerWrapper":"TEjrT"};